import { checkType, CheckType, errorMessage } from './shared';
import isValidCoMallElement from './isValidCoMallElement';
/**
 * 返回 children 中的元素数量
 * @param children
 */
function count(children) {
    if (checkType(children) === CheckType.Object && isValidCoMallElement(children)) {
        return 1;
    }
    if (Array.isArray(children)) {
        return children.length;
    }
    return 0;
}
/**
 * 验证 children 是否只是一个子节点，如果有则返回它，否则此方法会抛出错误
 * @param children
 */
function only(children) {
    if (Array.isArray(children) && children.length === 1) {
        const element = children[0];
        if (isValidCoMallElement(element)) {
            return element;
        }
    }
    if (checkType(children) === CheckType.Object) {
        if (isValidCoMallElement(children)) {
            return children;
        }
    }
    errorMessage('Children.only 只能接收一个 CoMallElement 子元素');
}
export default {
    count,
    only
};
//# sourceMappingURL=Children.js.map